<template>
  <div class="progress">
    <span
      class="used-bar"
      data-toggle="used-bar-tooltip"
      data-placement="bottom"
      :title="usedCredits"
      tabindex="0"
      :style="`width: ${usedPercent};`"
    ></span>
    <span
      class="remaining-bar"
      data-toggle="remaining-bar-tooltip"
      data-placement="bottom"
      :title="remainingCredits"
      tabindex="0"
      :style="`width: ${remainingPercent};`"
    ></span>
  </div>
</template>

<script>
export default {
  name: "ProcessBar",
  computed: {
    remainingCredits() {
      return "Available " + this.insertCommaInNumber(this.available);
    },
    usedCredits() {
      return "Used " + this.insertCommaInNumber(this.total - this.available);
    },
    usedPercent() {
      return this.total - this.available < 0
        ? "0%"
        : ((this.total - this.available) / this.total) * 100 + "%";
    },
    remainingPercent() {
      return this.available / this.total > 1
        ? "100%"
        : (this.available / this.total) * 100 + "%";
    }
  },

  props: {
    total: {
      type: Number,
      default: 50000
    },
    available: {
      type: Number,
      default: 0
    }
  },

  mounted() {
    $('[data-toggle="used-bar-tooltip"]').tooltip();
    $('[data-toggle="remaining-bar-tooltip"]').tooltip();
  }
};
</script>

<style scoped>
.progress {
  height: 2rem;
}

.used-bar {
  background-color: #dfdfdf;
}

.remaining-bar {
  background-color: #f5a623;
}

.used-bar:focus,
.remaining-bar:focus {
  outline: 0;
}
</style>







// WEBPACK FOOTER //
// src/components/bar/process-bar.vue